import './SlideMenu.css'

import React, { useState } from 'react'
import clsx from 'clsx'

import { useLocationChange } from '@/shared/makyo-hooks'
import { Close12 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

import { useAppContext } from '../../context/AppContext'

interface SlideMenuProps {
  /**
   * the state of the menu, if open it will be displayed
   */
  isOpen: boolean
  /**
   * callback when menu close button is clicked
   */
  onClose: () => void
  /**
   * slide menu content
   */
  children: React.ReactNode
}

/**
 * Slide menu only used in mobile screen
 */
export default function SlideMenu({ isOpen = false, onClose, children }: SlideMenuProps) {
  const [closing, setClosing] = useState(false)
  const close = () => {
    setClosing(true)
    setTimeout(() => {
      onClose()
    }, 400)
  }

  const { showSlideMenu, toggleSlideMenu } = useAppContext()

  useLocationChange((location, prev) => {
    if (prev === undefined || prev === null) {
      return
    } else {
      if (location.pathname !== prev.pathname && showSlideMenu) {
        toggleSlideMenu()
      }
    }
  })

  return (
    <>
      <div className={clsx('m-slide-menu', isOpen && !closing ? 'open' : 'closed')}>
        <div onClick={close} className='m-slide-menu-backdrop' />
        <div className='m-slide-menu-child bg-zinc-50 dark:bg-slate-800'>
          <div className='flex justify-end py-2'>
            <Button variant={ButtonVariant.Ghost} noPadding squared onClick={close} className='ltr:mr-2 rtl:ml-2'>
              <Close12 />
            </Button>
          </div>
          {children}
        </div>
      </div>
    </>
  )
}
